export const CRDS_COORDINATOR_WITH_ACTE_REMUNERATION_PREFIX = '271';
export const CRDS_COORDINATOR_WITH_MIXTE_REMUNERATION_PREFIX = '272';

export const CRDS_COORDINATOR_LUMPSUM_CODES = ['xxx287', 'xxx288', 'xxx289', 'xxx290', 'xxx291', 'xxx292'];

export const isCrdsCoordinationCode = (code) => CRDS_COORDINATOR_LUMPSUM_CODES.includes(code);
